enum ScreeningModalActionType {
    Activate = 'Activate',
    Cancel = 'Cancel',
    Continue = 'Continue',
    ScreenCandidate = 'ScreenCandidate'
}

export default ScreeningModalActionType
